module.exports = __webpack_public_path__ + "static/media/hcoe.9832ef1a.png";